import { TranslationDictionary } from "modules/translations/src/translation-context"

export default {
    "general.form-labels.search-placeholder": {
        "en-US": "Start searching",
        "nl-NL": "Start met zoeken",
    },
} as TranslationDictionary
